import React from 'react';
import { GridFooterContainer, GridPagination } from '@mui/x-data-grid';

/**
 * AdminDataGrid's footer when it has footerContent: that content on the left, the
 * pagination on the right (in place of the selected row count).
 */
export const AdminGridFooter = ({ content }) => (
	<GridFooterContainer sx={{ pl: 2 }}>
		{content}
		<GridPagination />
	</GridFooterContainer>
);

AdminGridFooter.displayName = 'AdminGridFooter';
